export default "__VITE_ASSET__DeQaXCr1__"